import ICON__eye_solid from '@/assets/icons/font_awesome/eye-solid.svg?react';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_ui } from '@/hooks/store/use_slices';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { ENUM__page_generation_layout } from '@/pages/page_generation/_enums/ENUM__page_generation_layout';
import { FN_FIELD_IMAGE__edit } from '@/pages/page_generation/sidebar/image_asset/_methods/FN_FIELD_IMAGE__edit';
import { FN_IMAGE__get_best_first_tab_for_image_edit } from '@/utils/_methods/FN_IMAGE__get_best_first_tab_for_image_edit';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';

interface PROPS {
  field: FIELD__list_image_asset;
}

export function G_GRAPH__BUTTON__list_images_view_in_fullscreen({ field }: PROPS) {
  /*
   * STORE
   */

  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   * EVENTS
   */

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    if (field.items.is_empty()) return;

    let field_item = field.items[0];

    let best_tab = FN_IMAGE__get_best_first_tab_for_image_edit(field_item);
    FN_FIELD_IMAGE__edit(field_item, ENUM__page_generation_layout.ASSETS, best_tab);
  }

  /*
   * METHODS
   */
  function is_disabled() {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */
  if (field.items.is_empty()) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />; //nothing to view
  if (!field.images_are_initialized()) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />; //nothing to view

  return (
    <UI_PRIMITIVE__button size={'square-6'} disabled={is_disabled()} variant={'no-border-on-bar'} {...{ onClick }} title="View image">
      <ICON__eye_solid className="!size-3" />
    </UI_PRIMITIVE__button>
  );
}
